module.exports = __webpack_public_path__ + "static/img/error_1.162a83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/error_1.png
// module id = oN2j
// module chunks = 1